import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f7eb3ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["type", "value"]

import { useRestrictNumberInput } from "@/composables";
import { FormFieldType } from "@/types/form";

interface Props {
  value: string;
  index: number;
}

interface IPartialInputEmitType {
  event: InputEvent;
  index: number;
}
interface IPartialKeyDownEmitType {
  event: KeyboardEvent;
  index: number;
}

interface Emits {
  (e: "updatePartialInput", arg: IPartialInputEmitType): void;
  (e: "handlePartialInputKeyDown", arg: IPartialKeyDownEmitType): void;
  (e: "pasteToPartialInputs", arg: ClipboardEvent): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PartialInput',
  props: {
    value: {},
    index: {}
  },
  emits: ["updatePartialInput", "handlePartialInputKeyDown", "pasteToPartialInputs"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;
const formFieldType = FormFieldType.Tel;

const updatePartialInput = (e: InputEvent): void => {
  emit("updatePartialInput", { event: e, index: props.index });
};

const handleInputKeyDown = (e: KeyboardEvent): void => {
  handleKeyDown(e);
  emit("handlePartialInputKeyDown", { event: e, index: props.index });
};

const { handleKeyDown, handleInput } = useRestrictNumberInput(
  formFieldType,
  updatePartialInput,
);

const pasteToPartialInputs = (e: ClipboardEvent): void => {
  emit("pasteToPartialInputs", e);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    type: _unref(formFieldType),
    value: _ctx.value,
    class: "partial-input",
    onInput: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleInput)($event as InputEvent))),
    onKeydown: handleInputKeyDown,
    onPaste: pasteToPartialInputs
  }, null, 40, _hoisted_1))
}
}

})